import React from "react";
import styled from "styled-components";
const CheckMarkSpan = styled.span`
  & {
    height: 15px;
    width: 15px;
    border-radius: 2px;
    border: 2px solid #522398;
    background-color: #fff;
    margin-right: 1.1rem;
  }
  input:checked ~ & {
    color: red;
    background-color: white;
  }
  &:after {
    content: " ";
    position: absolute;
    display: none;
  }
  input:checked ~ &:after {
    display: block;
    left: 4px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid #522398;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    position: relative;
  }
`;

export const CheckMark = () => {
  return <CheckMarkSpan> </CheckMarkSpan>;
};
